export default {"src":"/_next/static/media/private_token_icon.a5772e60.svg","height":1024,"width":1024};